import L from "leaflet"

let jsran = false
document.addEventListener("readystatechange", ev => {
    if (document.readyState === "interactive" || (document.readyState === "complete" && !jsran)) {
        jsran = true
        const latlong = [-36.9941, 174.8773]

        const mapcontainer = document.getElementById("map")
        const posinfo = mapcontainer.getBoundingClientRect();
        const height = posinfo.height;
        const width = posinfo.width;

        let map = L.map('map').setView(latlong, 16);
        let p = L.point(width/2, height/2)
        let pc = map.layerPointToLatLng(p)


        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }
        ).addTo(map);

        L.circle([pc.lat, pc.lng], { radius: 20, color: 'orange' }).addTo(map);
    }
})